declare var jQuery: any;

import '@burt-ui/semantic/definitions/modules/transition.js'
import '@burt-ui/semantic/definitions/modules/dropdown.js'

import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit
} from '@angular/core'

import { User } from '../../models/user.model';
import { MenuItem, MenuItemType } from '../../models/menu-item.model';

import { SessionService } from '../../services/session/session.service';
import { HubEventsService } from '../../services/hub-events/hub-events.service';

@Component({
  selector: 'hub-main-menu',
  templateUrl: './hub-main-menu.component.html',
  styleUrls: ['./hub-main-menu.component.less']
})
export class HubMainMenuComponent implements AfterViewInit {
  @ViewChild('elementRef') elementRef: ElementRef

  menuItems: MenuItem[]
  user: User
  hubUrl: string
  menuItemType = MenuItemType

  constructor(
    private sessionService: SessionService,
    private hubEventsService: HubEventsService
  ) {
    this.hubUrl = this.sessionService.hubUrl
    this.user = this.sessionService.user
    this.menuItems = this.sessionService.menuItems
  }

  ngAfterViewInit() {
    const $element: any = $(this.elementRef.nativeElement)
    $element.dropdown({direction: 'upward'})
  }

  fireEvent(eventName: string) {
    this.hubEventsService.next(eventName)
  }
}
